import Proxy from './Proxy';

class OrderProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('api/order', parameters);
  }

  /**
   * 발주 선택 삭제
   * @param list
   * @returns {Promise}
   */
  deleteById(list) {
    return this.submit('delete', `${this.endpoint}/${list}`);
  }

  /**
   * 발주 전체 삭제
   * @returns {Promise}
   */
  deleteAll() {
    return this.submit('delete', `${this.endpoint}`);
  }
}

export default OrderProxy;
